// Review draft + submit schemas.
import { z } from 'zod';

import { idSchema, richTextSchema } from './common.js';

// T4 — subject's counter-statement. 500-char cap; the route enforces the
// single-edit rule (first POST = write, second POST = edit, third = 409).
// Same control-char stripping behaviour as richTextSchema; min 1 so a caller
// can't silently wipe their response by submitting an empty body.
export const respondToReviewInputSchema = z.object({
  response_text: richTextSchema(500).refine((s) => s.trim().length >= 1, {
    message: 'Write at least a sentence — empty responses are not saved.',
  }),
});
export type RespondToReviewInput = z.infer<typeof respondToReviewInputSchema>;

const scoreSchema = z.number().int().min(1).max(5).nullable();

export const reviewScoresSchema = z.object({
  communication: scoreSchema,
  hospitality: scoreSchema,
  performance: scoreSchema,
  safety: scoreSchema,
  exchange_respected: scoreSchema,
});
export type ReviewScores = z.infer<typeof reviewScoresSchema>;

export const createOrUpdateReviewDraftInputSchema = z.object({
  exchange_id: idSchema,
  scores: reviewScoresSchema.partial(),
  free_text_public: richTextSchema(4000).optional(),
  private_note_to_team: richTextSchema(2000).optional(),
});
export type CreateOrUpdateReviewDraftInput = z.infer<
  typeof createOrUpdateReviewDraftInputSchema
>;

export const submitReviewInputSchema = z.object({
  exchange_id: idSchema,
  scores: reviewScoresSchema,
  free_text_public: richTextSchema(4000).refine((s) => s.trim().length >= 20, {
    message: 'Write at least a sentence so the other party has something to read.',
  }),
  private_note_to_team: richTextSchema(2000).optional(),
});
export type SubmitReviewInput = z.infer<typeof submitReviewInputSchema>;
